import { SiteActivityType } from 'common/activities/utils/types';

export const ACTIVITY_PATHS = {
    [SiteActivityType.SITE]: `/chart/:patientId/activity/${SiteActivityType.SITE}/:studyPk/:activitySk/:eventSk/:activityInstanceId?`,
    [SiteActivityType.HOME_TRANSCRIPTION]: `/chart/:patientId/activity/${SiteActivityType.HOME_TRANSCRIPTION}/:studyPk/:activitySk/:taskId/:activityInstanceId?/:episodic`,
    [SiteActivityType.HOME_VIEW]: `/chart/:patientId/activity/${SiteActivityType.HOME_VIEW}/:studyPk/:activitySk/:taskStatus/:taskId/:activityInstanceId?/:episodic`,
    [SiteActivityType.DCR]: `/chart/:patientId/activity/${SiteActivityType.DCR}/:studyPk/:activitySk/:taskId/:activityInstanceId?/:episodic`,
} as const;
